export const SET_INVOICE_TEMPLATES = 'SET_INVOICE_TEMPLATES'
